<template>
  <ul class="subMenu navbar">
    <li class="profileMenu">
      <router-link :to="{name: 'Profile'}">
        <i class="fa fa-bars"></i>
        Mon profil
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{name: 'Grades'}">
        <i class="fa fa-bars"></i>
        Grades
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{name: 'Stages'}">
        <i class="fa fa-bars"></i>
        Stages
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{name: 'Formations'}">
        <i class="fa fa-bars"></i>
        Formations
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{name: 'PalmaresCbt'}">
        <i class="fa fa-bars"></i>
        Palmarès combat
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{name: 'Arbitrage'}">
        <i class="fa fa-bars"></i>
        Arbitrage
      </router-link>
    </li>
    <!--        <li class="profileMenu">-->
    <!--            <router-link :to="{name: 'SyllabusEtDocuments'}">-->
    <!--                <i class="fa fa-bars"></i>-->
    <!--                Syllabus & documents-->
    <!--            </router-link>-->
    <!--        </li>-->
    <!--        <li class="profileMenu">-->
    <!--            <router-link :to="{name: 'PalmaresPoomsae'}">-->
    <!--                <i class="fa fa-bars"></i>-->
    <!--                Palmarès poomsae-->
    <!--            </router-link>-->
    <!--        </li>-->
    <!--<li class="profileMenu"><a><i class="fa fa-bars"></i> FAQ</a></li>-->

    <li class="drowdown pull-right">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
        Mon club <span class="caret"></span>
      </a>
      <ul class="dropdown-menu" role="menu">
        <li v-if="getMember.clubsMyAbft != null && getMember.clubsMyAbft.length>0" class="header">Mes clubs:</li>
        <li v-for="(club,index) in getMember.clubsMyAbft">
          <a @click.prevent="goToClubForm({id:club.club_id,club_slug:club.club_slug})">{{club.club}}</a>
        </li>
        <hr v-if="getMember.clubsMyAbft != null && getMember.clubsMyAbft.length>0">
        <li>
          <a @click.prevent="logout()" href="">Déconnexion</a>
        </li>
      </ul>
    </li>

    <!--        <li class="profileMenu  pull-right" v-if="true">-->
    <!--            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">-->
    <!--                <i class="fa fa-shopping-cart"></i>-->
    <!--                <span data-toggle="tooltip" title="" class="badge bg-light-blue" :data-original-title="getNumberOfItemsInCart()">{{getNumberOfItemsInCart()}}</span>-->
    <!--            </a>-->
    <!--            <ul class="dropdown-menu" role="cart">-->
    <!--                <li v-for="(item,index) in getCart">-->
    <!--                    {{index}} - {{item.quantity}}-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                    <router-link :to="{name: 'Panier'}">-->
    <!--                        Voir le panier-->
    <!--                    </router-link>-->
    <!--                </li>-->
    <!--            </ul>-->
    <!--        </li>-->


  </ul>
</template>

<script type="text/babel">
  import Auth from '@/auth'
  import {mapGetters, mapActions} from 'vuex'

  var _ = require('lodash');

  export default {
    data() {
      return {}
    },
    methods: {
      ...mapActions({
        setIdClubSelected: 'setIdClubSelected',
        setClub: 'setClub',
        setLoading: 'setLoading',
        setAllDataToLocalStorage: 'setAllDataToLocalStorage',
      }),
      goToClubForm: function (object) {
        // this.setLoading(true)
        this.setIdClubSelected(object.id)
        // this.setAllDataToLocalStorage()
        this.$router.push({
          name: 'MainFormClub',
          params: {
            club: object.club_slug
          }
        })
      },
      logout: function () {
        Auth.logout();
      },

      getNumberOfItemsInCart: function () {
        let quantity = 0
        _.map(this.getCart, item => quantity += item.quantity)
        return quantity;
      }
    },
    components: {},
    computed: {
      ...mapGetters({
        getCart: 'getCart',
        getMember: 'getMember',
      })
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Member/Subnavbar.vue